/**
 * 현재 페이지 url에 대하여
 * product 하위 페이지 여부 확인
 */
// eslint-disable-next-line import/prefer-default-export
export const checkProductPathMixin = {
  data() {
    return {
      isProduct: false,
    };
  },
  watch: {
    $route(to, from) {
      if (to.path !== from.path) {
        this.isProduct = to.path.indexOf('/product') >= 0;
      }
    },
  },
};
